import { Fragment } from "react";
import { Link } from "react-router";

import { Box } from "@design-system/Box/Box";
import { Icon } from "@design-system/Icon/Icon";
import { Tag } from "@design-system/Tag/Tag";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

import classes from "./CategoryChainChips.module.css";

export type CategoryChain = {
  id: string;
  name: string;
  parent?: {
    id: string;
    name: string;
  } | null;
} | null;

type Props = {
  clientId: string;
  category?: CategoryChain;
};

const applicationsPath = (clientId: string, parentCategoryId: string) =>
  routes.portal.clients.client.applications.$buildPath({
    params: { clientId },
    searchParams: { parentCategoryId },
  });

export const CategoryChainChips = ({ clientId, category }: Props) => {
  if (!category?.id || !category.name) {
    return (
      <Text size={14} color="textSecondary">
        —
      </Text>
    );
  }

  const chips = [
    ...(category.parent?.id && category.parent.name
      ? [{ id: category.parent.id, name: category.parent.name }]
      : []),
    { id: category.id, name: category.name },
  ];

  return (
    <Box direction="row" gap={8} align="center" wrap>
      {chips.map((chip, index) => (
        <Fragment key={chip.id}>
          {index > 0 && (
            <Icon
              icon="faChevronRight"
              size="xs"
              className={classes.separator}
            />
          )}
          <Link
            className={classes.chip}
            to={applicationsPath(clientId, chip.id)}
          >
            <Tag color="secondary" text={chip.name} />
          </Link>
        </Fragment>
      ))}
    </Box>
  );
};
